import NewPromiseScreen from './NewPromiseScreen';

export default NewPromiseScreen;
